const environments = {
  VITE_APP_STRIPE_API_KEY: import.meta.env.VITE_APP_STRIPE_API_KEY,
  VITE_APP_IS_SDK:
    import.meta.env.VITE_APP_IS_SDK && JSON.parse(import.meta.env.VITE_APP_IS_SDK),
  VITE_APP_DEFAULT_LANGUAGE: import.meta.env.VITE_APP_DEFAULT_LANGUAGE,
  VITE_APP_VARIANT: import.meta.env.VITE_APP_VARIANT || 'default',
};

type EnvsKeys = keyof typeof environments;

function getEnvVariable(key: EnvsKeys) {
  const variable = environments[key];

  if (!variable) {
    throw new Error(`${key} .env variable is missing.`);
  }

  return variable;
}

export {environments, getEnvVariable};
